import { apiClient } from '@/services/ApiClient.js'

export default {
  getBankPayments(query) {
    return apiClient
      .get('bulut-tahsilat/bank-payments', {
        params: query
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBankPayment(bankPaymentId) {
    return apiClient
      .get(`bulut-tahsilat/bank-payments/${bankPaymentId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getOrder(bankPaymentId, orderId) {
    return apiClient
      .get(`bulut-tahsilat/bank-payments/${bankPaymentId}/orders/${orderId}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getBankPaymentActivities(id) {
    return apiClient
      .get(`bulut-tahsilat/bank-payments/${id}/activities`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  approveBankPayment(id, calculationDate = null, fullyPaidConfirmation = null, notifyFarmer = null) {
    let payload = {}

    if (calculationDate) {
      payload.calculation_date = calculationDate
    }

    if (fullyPaidConfirmation) {
      payload.fully_paid_confirmation = fullyPaidConfirmation
    }

    if (notifyFarmer) {
      payload.notify_farmer = notifyFarmer
    }

    return apiClient
      .post(`bulut-tahsilat/bank-payments/${id}/approve`, payload)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  matchOrderForBankPayment(data) {
    return apiClient
      .patch(`bulut-tahsilat/bank-payments/${data.selectedData.id}/order/${data.selectedData.order_id}/match`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  unmatchOrderForBankPayment(data) {
    return apiClient
      .patch(`bulut-tahsilat/bank-payments/${data.selectedData.id}/order/${data.selectedData.order_id}/unmatch`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  markAsManualCollection(id, transactionId) {
    return apiClient
      .post(`bulut-tahsilat/bank-payments/${id}/mark-as-manual-collection`, {
        transaction_id: transactionId
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteBankPayment(id) {
    return apiClient
      .delete(`bulut-tahsilat/bank-payments/${id}`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  deleteBankPaymentWithRefund(id) {
    return apiClient
      .delete(`bulut-tahsilat/bank-payments/${id}/delete-with-refund`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getTransactions(id, orderId) {
    return apiClient
      .get(`bulut-tahsilat/bank-payments/${id}/orders/${orderId}/transactions`)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  recalculateRemainingDebt(id, calculationDate) {
    return apiClient
      .post(`bulut-tahsilat/bank-payments/${id}/recalculate-remaining-debt`, {
        calculation_date: calculationDate
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  simulatePayment(id, calculationDate = null) {
    return apiClient
      .post(
        `bulut-tahsilat/bank-payments/${id}/simulate-payment`,
        calculationDate ? { calculation_date: calculationDate } : {}
      )
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
